var _a;
import { generateActions } from "../generators/generator.actions";
import { GENERATOR_PARAMS } from "./report.beneficiary.constants";
export var getPagedStart = (_a = generateActions(GENERATOR_PARAMS), _a.getPagedStart), getPagedFailed = _a.getPagedFailed, getPagedSucceeded = _a.getPagedSucceeded, getCountStart = _a.getCountStart, getCountFailed = _a.getCountFailed, getCountSucceeded = _a.getCountSucceeded;
